import DividerWithHex from "@/components/modal-dark/components/divider-with-hex/DividerWithHex"
import Typography from "@/components/typography/Typography"
import BookDemoButton from "@/components/website/book-demo-button/BookDemoButton"
import { useBreakpoint } from "@/hooks/useBreakpoint"
import StepCard, {
  STEP_ICONS_MAP,
} from "@/pages/website-landing/home/new-sections/start-guide-steps/step-card/StepCard"
import { Col, Row } from "antd"
import { FC } from "react"
import "./StartGuideSteps.less"

import bgImage from "./assets/half-logo.webp"

const { Title, Paragraph } = Typography

type Props = {
  paddingBottom?: number
}

const StartGuideSteps: FC<Props> = ({ paddingBottom }) => {
  const { xxl, xl, lg, md, sm, xs } = useBreakpoint()

  return (
    <div className={"guide-steps-wrapper"} style={{ paddingBottom: paddingBottom ?? undefined }}>
      <div className={"bg-img-wrapper"}>
        <img src={bgImage} alt={""} loading={"lazy"} decoding={"async"} />
      </div>

      <div className={"container"}>
        <Row justify={xxl || xl || lg || md ? "end" : "center"}>
          <Col
            style={{ paddingRight: xxl || xl || lg || md ? 80 : 0, paddingBottom: !(xxl || xl || lg || md) ? 24 : 0 }}
          >
            <Title
              level={xxl || xl || lg || md || sm ? 2 : 3}
              color={"white"}
              style={{
                fontSize: !(xxl || xl) ? undefined : 50,
              }}
              centered={!(xxl || xl || lg || md)}
            >
              <span>{"Get started in\n"}</span>
              <span className={"bold orange"}>{"3 simple steps"}</span>
            </Title>

            <Paragraph
              color={"website-secondary"}
              size={"md"}
              style={{ paddingTop: 24 }}
              lh={"lh-lg"}
              centered={!(xxl || xl || lg || md)}
            >
              {"No complicated setup. No lengthy\nimplementation. Just a faster way to\nmanage wayleaves."}
            </Paragraph>
          </Col>
        </Row>

        <Row justify={!(xxl || xl || lg || md) ? "center" : "start"}>
          <div className={"steps-card-box"}>
            <div className={"left"}>
              <StepCard
                icon={STEP_ICONS_MAP["calendarBlank"]}
                numberOfStep={1}
                title={"Book a Demo"}
                description={
                  "We'll show you how Easetech can simplify your wayleave process and help your team achieve more."
                }
                line={true}
              />
            </div>
            <div className={"center"}>
              <StepCard
                icon={STEP_ICONS_MAP["checkSquareOffset"]}
                numberOfStep={2}
                title={"Choose the right package"}
                description={"Select the solution that best suits your business and operational needs."}
              />
            </div>
            <div className={"right"}>
              <StepCard
                numberOfStep={3}
                icon={STEP_ICONS_MAP["gear"]}
                title={"Start processing wayleaves"}
                description={"Get set up instantly and start managing applications with ease."}
              />
            </div>
          </div>
        </Row>

        <Row justify={"center"} style={{ paddingBottom: 32 }}>
          <Paragraph color={"website-secondary"} size={"md"} centered={!(xxl || xl || lg || md)}>
            {"From demo to deployment, getting started is simple, fast, and risk-free."}
          </Paragraph>
        </Row>

        <Row justify={"center"} style={{ paddingBottom: 64 }}>
          {xxl || xl || lg || md || sm ? (
            <div className={"steps-banner-wrapper"}>
              <StepCard
                icon={STEP_ICONS_MAP["circleTick"]}
                title={"Flexible, risk-free pricing:"}
                description={
                  "Our month-to-month packages are designed to be affordable, scalable, and risk-free — allowing you to start small, grow as needed, and only pay for what your business requires."
                }
              />
            </div>
          ) : (
            <Col className={"start-note-info-wrapper"}>
              <Paragraph color={"white"} size={"md"} centered style={{ paddingBottom: 16 }}>
                {"Flexible, risk-free pricing:"}
              </Paragraph>
              <DividerWithHex color={"blue-gray"} marginTop={0} marginBottom={8} />
              <Paragraph color={"website-secondary"} size={"sm"} centered lh={"lh-lg"}>
                {
                  "Our month-to-month packages are designed to be affordable, scalable, and risk-free — allowing you to start small, grow as needed, and only pay for what your business requires."
                }
              </Paragraph>
            </Col>
          )}
        </Row>

        <Row justify={"center"} style={{ paddingBottom: 64 }}>
          <BookDemoButton type={"orange"} />
        </Row>
      </div>
    </div>
  )
}

export default StartGuideSteps
